export default __webpack_public_path__ + "static/media/bubble_1_left.acf143d3.png";